import React, { useState } from "react";
import { Box, Button, Grid, Typography, Link } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const DineroSuccessMessage = ({ transferredData, isAllDataFailError }) => {
    const history = useHistory();
    const { invoice, contact, product } = transferredData;
    const [invoiceError, setInvoiceError] = useState(false);
    const [productError, setProductError] = useState(false);
    const [contactError, setContactError] = useState(false);
    const onInvoiceToggle = status => {
        setInvoiceError(status);
    };
    const onProductToggle = status => {
        setProductError(status);
    };
    const onContactToggle = status => {
        setContactError(status);
    };
    return (
        <>
            {!isAllDataFailError ? (
                <Box
                    padding={5}
                    style={{
                        width: "fit-content",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                    <img src="images/success.svg" alt="success" height="70px" width="70px" />
                    <Typography variant="h4" style={{ fontWeight: 400, marginTop: "16px" }}>
                        Overførsel Fuldført{" "}
                    </Typography>

                    <Box mt={"25px"} textAlign="center">
                        <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                            Fakturaer fundet: {invoice.total}
                        </Typography>
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                            {invoice.success} Ny overført uden problemer
                        </Typography>
                        {invoice.alreadyAdded !== 0 && (
                            <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                                {invoice.alreadyAdded} Allerede overført
                            </Typography>
                        )}
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#D03131" }}>
                            {invoice.fail} Fejlede under Overførsel.{" "}
                        </Typography>
                        {invoice.fail > 0 && invoice.error && (
                            <>
                                {!invoiceError && (
                                    <Typography
                                        onClick={() => onInvoiceToggle(true)}
                                        style={{ textDecoration: "underline", color: "black", cursor: "pointer" }}>
                                        se mere
                                    </Typography>
                                )}
                                {invoiceError && (
                                    <>
                                        <Grid style={{ transition: "ease 0.3s all" }}>
                                            <Typography
                                                style={{
                                                    borderTop: "1px solid #00000033",
                                                    marginTop: "5px",
                                                    paddingTop: "5px"
                                                }}>
                                                {invoice.error}
                                            </Typography>
                                        </Grid>
                                        <Typography
                                            onClick={() => onInvoiceToggle(false)}
                                            style={{
                                                textDecoration: "underline",
                                                color: "#0B54B3",
                                                cursor: "pointer",
                                                marginTop: "15px"
                                            }}>
                                            mindre mere
                                        </Typography>
                                    </>
                                )}
                            </>
                        )}
                        {invoice.fail > 0 && invoice.error === "" && (
                            <>
                                <Typography>
                                    Fejl i overførelsen{" "}
                                    <Link
                                        href="https://handsonbooking.dk/kontakt.aspx"
                                        target="_blank"
                                        style={{
                                            color: "#0B54B3",
                                            fontFamily: "Roboto",
                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            textDecoration: "underline"
                                        }}>
                                        Kontakt Support
                                    </Link>
                                </Typography>
                            </>
                        )}
                    </Box>

                    <Box mt={"25px"} textAlign="center">
                        <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                            Behandlinger fundet: {product.total}{" "}
                        </Typography>
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                            {product.success} Ny overført uden problemer
                        </Typography>
                        {product.alreadyAdded !== 0 && (
                            <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                                {product.alreadyAdded} Allerede overført
                            </Typography>
                        )}
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#D03131" }}>
                            {product.fail} Fejlede under Overførsel.{" "}
                        </Typography>
                        {product.fail > 0 && product.error && (
                            <>
                                {!productError && (
                                    <Typography
                                        onClick={() => onProductToggle(true)}
                                        style={{ textDecoration: "underline", color: "black", cursor: "pointer" }}>
                                        se mere
                                    </Typography>
                                )}
                                {productError && (
                                    <>
                                        <Grid>
                                            <Typography
                                                style={{
                                                    borderTop: "1px solid #00000033",
                                                    marginTop: "5px",
                                                    paddingTop: "5px"
                                                }}>
                                                {product.error}
                                            </Typography>
                                        </Grid>
                                        <Typography
                                            onClick={() => onProductToggle(false)}
                                            style={{
                                                textDecoration: "underline",
                                                color: "#0B54B3",
                                                cursor: "pointer",
                                                marginTop: "15px"
                                            }}>
                                            mindre mere
                                        </Typography>
                                    </>
                                )}
                            </>
                        )}
                        {product.fail > 0 && product.error === "" && (
                            <>
                                <Typography>
                                    Fejl i overførelsen{" "}
                                    <Link
                                        href="https://handsonbooking.dk/kontakt.aspx"
                                        target="_blank"
                                        style={{
                                            color: "#0B54B3",
                                            fontFamily: "Roboto",
                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            textDecoration: "underline"
                                        }}>
                                        Kontakt Support
                                    </Link>
                                </Typography>
                            </>
                        )}
                    </Box>

                    <Box mt={"25px"} textAlign="center">
                        <Typography variant="subtitle1" style={{ fontWeight: "500" }}>
                            Patienter fundet: {contact.total}{" "}
                        </Typography>
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                            {contact.success} Ny overført uden problemer
                        </Typography>
                        {contact.alreadyAdded !== 0 && (
                            <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#23AF0C" }}>
                                {contact.alreadyAdded} Allerede overført
                            </Typography>
                        )}
                        <Typography variant="subtitle1" style={{ fontWeight: "500", color: "#D03131" }}>
                            {contact.fail} Fejlede under Overførsel.{" "}
                        </Typography>
                        {contact.fail > 0 && contact.error && (
                            <>
                                {!contactError && (
                                    <Typography
                                        onClick={() => onContactToggle(true)}
                                        style={{ textDecoration: "underline", color: "black", cursor: "pointer" }}>
                                        se mere
                                    </Typography>
                                )}
                                {contactError && (
                                    <>
                                        <Grid>
                                            <Typography
                                                style={{
                                                    borderTop: "1px solid #00000033",
                                                    marginTop: "5px",
                                                    paddingTop: "5px"
                                                }}>
                                                {contact.error}
                                            </Typography>
                                        </Grid>
                                        <Typography
                                            onClick={() => onContactToggle(false)}
                                            style={{
                                                textDecoration: "underline",
                                                color: "#0B54B3",
                                                cursor: "pointer",
                                                marginTop: "15px"
                                            }}>
                                            mindre mere
                                        </Typography>
                                    </>
                                )}
                            </>
                        )}
                        {contact.fail > 0 && contact.error === "" && (
                            <>
                                <Typography>
                                    Fejl i overførelsen{" "}
                                    <Link
                                        href="https://handsonbooking.dk/kontakt.aspx"
                                        target="_blank"
                                        style={{
                                            color: "#0B54B3",
                                            fontFamily: "Roboto",
                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            textDecoration: "underline",
                                            display: "inline-block"
                                        }}>
                                        Kontakt Support
                                    </Link>
                                </Typography>
                            </>
                        )}
                    </Box>

                    <Button
                        variant="contained"
                        onClick={() => history.push("/Kalender")}
                        style={{
                            textTransform: "capitalize",
                            paddingLeft: "30px",
                            paddingRight: "30px",
                            backgroundColor: "#23AF0C",
                            color: "#ffff",
                            marginTop: "40px",
                            borderRadius: "6px",
                            fontWeight: "400",
                            minWidth: "160px",
                            boxShadow: "none",
                            minHeight: "40px",
                            display: "flex",
                            alignItems: "center"
                        }}>
                        Fortsæt
                    </Button>
                </Box>
            ) : (
                <Box
                    padding={5}
                    style={{
                        width: "fit-content",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                    <img src="images/close.svg" alt="success" height="70px" width="70px" />
                    <Typography
                        variant="h4"
                        style={{
                            fontWeight: 500,
                            marginTop: "16px",
                            fontSize: "22px",
                            color: "black",
                            textAlign: "center"
                        }}>
                        Overførelse fejlede
                    </Typography>

                    <Button
                        variant="contained"
                        onClick={() => history.push("/Kalender")}
                        style={{
                            textTransform: "capitalize",
                            paddingLeft: "50px",
                            paddingRight: "50px",
                            backgroundColor: "#23AF0C",
                            color: "#ffff",
                            marginTop: "40px"
                        }}>
                        Fortsæt
                    </Button>
                    <Typography
                        variant="p"
                        style={{ fontWeight: 400, marginTop: "14px", color: "black", textAlign: "center" }}>
                        Fejl i overførelsen{" "}
                        <Link
                            href="https://handsonbooking.dk/kontakt.aspx"
                            target="_blank"
                            style={{
                                color: "#0B54B3",
                                fontFamily: "Roboto",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                                textDecoration: "underline",
                                display: "inline-block"
                            }}>
                            Kontakt Support
                        </Link>
                    </Typography>
                </Box>
            )}
        </>
    );
};

export default DineroSuccessMessage;
